import squadcode from '../../../img/squadcode.png';
import './Projectleftimage.css';

const ProjectImage = () => {
  return (
    <img 
      src={squadcode} 
      alt="SquadCode collaborative coding application" 
      className="photossss reveal fade-left" 
    />
  );
};

export default ProjectImage;
